import { __awaiter, __generator } from "tslib";
import { Formik } from 'formik';
import React from 'react';
import './EmailForm.scss';
var EmailForm = function (_a) {
    var submitLabel = _a.submitLabel, cancelLabel = _a.cancelLabel, inputPlaceholder = _a.inputPlaceholder, email = _a.email, handleSubmit = _a.handleSubmit, handleCancel = _a.handleCancel;
    return (React.createElement(Formik, { initialValues: { email: email || '' }, validate: function (values) {
            var errors = {};
            if (!values.email) {
                errors.email = 'Povinné';
            }
            else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)) {
                errors.email = 'Zadejte platnou emailovou adresu';
            }
            return errors;
        }, validateOnBlur: false, validateOnChange: false, onSubmit: function (values, _a) {
            var setSubmitting = _a.setSubmitting, resetForm = _a.resetForm;
            setTimeout(function () { return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, handleSubmit(values)];
                        case 1:
                            _a.sent();
                            resetForm();
                            setSubmitting(false);
                            return [2 /*return*/];
                    }
                });
            }); }, 400);
        } }, function (_a) {
        var values = _a.values, errors = _a.errors, touched = _a.touched, handleChange = _a.handleChange, handleBlur = _a.handleBlur, handleSubmit = _a.handleSubmit, isSubmitting = _a.isSubmitting, resetForm = _a.resetForm;
        return (React.createElement("form", { className: "email-form", onSubmit: handleSubmit },
            React.createElement("div", { className: "flex column" },
                React.createElement("input", { type: "text", name: "email", className: errors.email && 'error', placeholder: inputPlaceholder, onChange: handleChange, onBlur: handleBlur, value: values.email }),
                React.createElement("span", { className: "error" }, errors.email && touched.email && errors.email)),
            React.createElement("div", { className: "flex center" },
                React.createElement("button", { className: "submit", type: "submit", disabled: isSubmitting }, submitLabel),
                React.createElement("button", { onClick: function (e) {
                        e.preventDefault();
                        resetForm();
                        handleCancel(e);
                    }, className: "cancel", disabled: isSubmitting }, cancelLabel))));
    }));
};
export default EmailForm;
